import { useState } from "react";
import {
  fetchExportAuditPage,
  type ExportAuditEntry,
  type ExportAuditPage,
} from "@/lib/api/organizations";
import {
  usePagedLog,
  type PagedLog,
} from "@/components/main/governance/usePagedLog";

export interface ExportFeed extends PagedLog<ExportAuditEntry> {
  /// The org's plan does not include the log.
  locked: boolean;
}

/// The org's exports, newest first.
export function useExportAudit(
  orgId: string | null,
  pageSize = 100,
  admin = false,
): ExportFeed {
  const [locked, setLocked] = useState(false);

  const feed = usePagedLog<ExportAuditEntry, string, ExportAuditPage>({
    key: orgId && `${orgId}|${pageSize}|${admin}`,
    // A refusal (403) hides the tab, as the governance log's does.
    first: () =>
      fetchExportAuditPage(orgId!, { limit: pageSize, admin }).catch(
        () => null,
      ),
    next: (before) =>
      fetchExportAuditPage(orgId!, { before, limit: pageSize, admin }),
    onPage: async (page, first) => () => {
      if (first) setLocked(!page.available);
    },
    errorLabel: "Could not load more exports. Try again.",
  });

  return { ...feed, locked };
}
